export default __webpack_public_path__ + "static/media/PPD CONTACTLESS.21f57e51.jpg";